import { v4 as uuidv4 } from "uuid";
import { NoteBlock } from "../block";
export interface DevcontainerBlock extends NoteBlock {
  "devcontainer-id": string;
  type: "omega/query-omega/page/block/devcontainer/DevContainerBlock";
}
export function isDevcontainerBlock(block: NoteBlock): block is DevcontainerBlock {
  return (block as DevcontainerBlock)["devcontainer-id"] !== undefined;
}
export const newDevcontainerBlock = (config: {
  appId: string; pageId: string; devcontainerId: string; blockIndex: number;
}): DevcontainerBlock => {
  const { appId, pageId, devcontainerId, blockIndex } = config;
  return {
    "devcontainer-id": devcontainerId,
    type: "omega/query-omega/page/block/devcontainer/DevContainerBlock",
    "block-index": blockIndex, "page-id": pageId, "app-id": appId, "block-id": uuidv4(),
  };
};
